import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import functions from '../../../index'
import { SelectOption } from '../../../../containers/BulkSheetView/components/cellEditor/MultiSelectCellEditor'
import { PermissionPolicyOption } from '../../model/PermissionPolicyOption'

export const useAttachablePermissionPolicyOptions = (
  permissionPolicyOptions: PermissionPolicyOption[]
) => {
  const intl = useIntl()
  const availableFunctionsTitle = useMemo(
    () =>
      intl.formatMessage({ id: 'permissionPolicy.available.functions.title' }),
    [intl]
  )
  const attachablePermissionPolicyOptions: SelectOption[] = useMemo(
    () =>
      permissionPolicyOptions
        .filter(p => p.attachable)
        .map(p => {
          const tooltipLines: string[] = []
          if (p.description) {
            tooltipLines.push(p.description)
            tooltipLines.push('')
          }
          tooltipLines.push(availableFunctionsTitle)
          p.scopes.forEach(s => {
            if (
              s.applicationFunction &&
              functions[s.applicationFunction.externalId] // feature-flagで非表示にされる機能を除くための条件
            ) {
              tooltipLines.push(`${s.applicationFunction.name} ${s.operation}`)
            }
          })
          return {
            value: p.uuid,
            label: p.name,
            tooltip: tooltipLines.join('\n'),
            disabled: p.attachedByDefault || !p.attachable,
          }
        }),
    [permissionPolicyOptions, availableFunctionsTitle]
  )

  return attachablePermissionPolicyOptions
}
